import React from 'react';
import { Control, Controller, ControllerProps } from 'react-hook-form';
import { OutlinedInputProps } from '@mui/material';
import { convertStringToNumber } from '@/main/services/utilsString';

import KogInputTextOutlined from './inputTextOutlined';

type IControllerProps = Omit<ControllerProps, 'render' | 'name'>;

export type TextInputProps = {
  errorMessageCustom?: string;
  name: string;
  control: Control<any>;
  controllerProps?: IControllerProps;
  hasOnlyNumber?: boolean;
  hasOnlyNumberInteger?: boolean;
  disabledMessage?: boolean;
  hideValue?: boolean;
  onChangeCustom?: (value: string) => void;
};

type KogInputTextControlledNewProps = TextInputProps & OutlinedInputProps

const KogInputTextOutlinedControlled = ({
  name,
  control,
  errorMessageCustom,
  controllerProps,
  hasOnlyNumber = false,
  hasOnlyNumberInteger = false,
  disabledMessage = false,
  hideValue = false,
  onChangeCustom = () => { },
  ...props }: KogInputTextControlledNewProps) => {
  function handleValueChange(value: string) {

    return convertStringToNumber(value, {
      hasOnlyNumber,
      hasOnlyNumberInteger
    });
  }

  return (
    <Controller
      name={name}
      control={control}
      {...controllerProps}
      render={({
        field: { ref, ...field },
        fieldState: { error }
      }) => (
        <KogInputTextOutlined
          required={Boolean(controllerProps?.rules?.required)}
          error={!!error}
          inputProps={props.inputProps ? props.inputProps : { maxLength: 100 }}
          inputRef={ref}
          {...field}
          {...props}
          onChange={(e) => {
            const validateValue = handleValueChange(e.target.value);

            field.onChange(validateValue);
            onChangeCustom(validateValue);
          }}
          value={hideValue ? '' : field.value}
        />
      )}
    />

  );
};

export default KogInputTextOutlinedControlled;
